<div class="agpr-distributionGlobalCustomization">
    <agpr-panel header="Discover.targeting.distribution.rhp.generalStylesHeader">
        <agpr-image-style-field
            [id]="id + '_image'"
            [field]="imageField"
            [value]="focusedDistribution?.generalStyles[distributionBlockTypeEnum.image]"
            (changes)="styleChange($event, distributionBlockTypeEnum.image)"
        ></agpr-image-style-field>
        <agpr-text-style-field
            [id]="id + '_title'"
            [field]="titleField"
            [value]="focusedDistribution?.generalStyles[distributionBlockTypeEnum.title]"
            (changes)="styleChange($event, distributionBlockTypeEnum.title)"
        ></agpr-text-style-field>
        <agpr-text-style-field
            [id]="id + '_body'"
            [field]="textField"
            [value]="focusedDistribution?.generalStyles[distributionBlockTypeEnum.text]"
            (changes)="styleChange($event, distributionBlockTypeEnum.text)"
        ></agpr-text-style-field>
        <agpr-divider-style-field
            [id]="id + '_divider'"
            [field]="dividerField"
            [value]="focusedDistribution?.generalStyles[distributionBlockTypeEnum.divider]"
            (changes)="styleChange($event, distributionBlockTypeEnum.divider)"
        ></agpr-divider-style-field>
        <agpr-button-style-field
            [id]="id + '_button'"
            [field]="buttonField"
            [value]="focusedDistribution?.generalStyles[distributionBlockTypeEnum.button]"
            (changes)="styleChange($event, distributionBlockTypeEnum.button)"
        ></agpr-button-style-field>
        <agpr-links-style-field
            [id]="id + '_link'"
            [field]="linkField"
            [value]="focusedDistribution?.generalStyles[distributionBlockTypeEnum.link]"
            (changes)="styleChange($event, distributionBlockTypeEnum.link)"
        ></agpr-links-style-field>
        @if (focusedDistribution) {
            <agpr-layout-style-field
                [id]="id + '_oneColumnLayout'"
                [field]="oneColumnLayoutField"
                [value]="focusedDistribution.generalStyles[distributionBlockTypeEnum.oneColumnLayout]"
                (changes)="styleChange($event, distributionBlockTypeEnum.oneColumnLayout)"
            ></agpr-layout-style-field>
            <agpr-layout-style-field
                [id]="id + '_twoColumnLayout'"
                [field]="twoColumnLayoutField"
                [value]="focusedDistribution.generalStyles[distributionBlockTypeEnum.twoColumnLayout]"
                (changes)="styleChange($event, distributionBlockTypeEnum.twoColumnLayout)"
            ></agpr-layout-style-field>
            <agpr-layout-style-field
                [id]="id + '_threeColumnLayout'"
                [field]="threeColumnLayoutField"
                [value]="focusedDistribution.generalStyles[distributionBlockTypeEnum.threeColumnLayout]"
                (changes)="styleChange($event, distributionBlockTypeEnum.threeColumnLayout)"
            ></agpr-layout-style-field>
        }
        <agpr-text-style-field
            [id]="id + '_footer'"
            [field]="footerField"
            [value]="footerDisplayElement?.styles"
            (changes)="styleChange($event, distributionBlockTypeEnum.footer)"
        ></agpr-text-style-field>
    </agpr-panel>
</div>
